import { CatListItem } from '@blocks-react/components/ListItem';
import { CatHeading } from '@blocks-react/components/Heading';
import cx from 'classnames';
import { MAIN_NAV_TRACK } from '../../../constants/analyticsConstants';
import styles from './style.module.scss';

interface CategoriesListProps {
  heading: string;
  subHeading: string;
  isMD: boolean;
  subTitle?: string;
  seoUrlKeyword?: string;
  handleRedirect: (e: Event, seoUrlKeyword: string | undefined) => void;
  categoryIdentifier: string;
}

export const CategoriesList = ({
  heading,
  subHeading,
  isMD,
  subTitle,
  seoUrlKeyword,
  handleRedirect,
  categoryIdentifier
}: CategoriesListProps) => {
  return (
    <>
      <CatListItem
        isStatic
        aria-label={heading}
        className={!isMD ? 'd-none' : `d-block ${styles['title-padding']}`}
      >
        <CatHeading
          variant="display-sm"
          data-track-event={MAIN_NAV_TRACK.EVENT}
          data-track-attr-nltext={categoryIdentifier}
          data-track-attr-context={MAIN_NAV_TRACK.TOP_SUBMENU_CONTEXT}
        >
          {heading}
        </CatHeading>
      </CatListItem>
      <CatListItem
        aria-label={`${subTitle} ${subHeading}`}
        data-track-event={MAIN_NAV_TRACK.EVENT}
        data-track-attr-nltext={`See All ${categoryIdentifier}`}
        data-track-attr-context={MAIN_NAV_TRACK.TOP_SUBMENU_CONTEXT}
        onBlSelect={(e: Event) => {
          handleRedirect(e, seoUrlKeyword);
        }}
      >
        <label
          className={cx(styles['subheading'], {
            [styles['subheading__mobile']]: !isMD
          })}
        >
          {`${subTitle?.replace('category-name', subHeading)}`}
        </label>
      </CatListItem>
    </>
  );
};
